import profilesApi from "../../api/profilesApi";

const state = { profiles: [] };

const actions = {
    createProfile({ commit }, profile) {
        return new Promise((resolve, reject) => {
            profilesApi.store(profile)
                .then((response) => {
                    if (response.status === 201) {
                        commit("ADD_PROFILE", response.data.profile);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    getProfiles({ commit }) {
        return new Promise((resolve, reject) => {
            profilesApi
                .all()
                .then((response) => {
                    if (response.status === 200) {
                        commit("SET_PROFILE", response.data);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    updateProfile({ commit }, data) {
        return new Promise((resolve, reject) => {
            profilesApi
                .update(data)
                .then((response) => {
                    if (response.status === 200) {
                        commit("UPDATE_PROFILE", response.data.profile);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    deleteProfile({ commit }, profileID) {
        return new Promise((resolve, reject) => {
            profilesApi
                .delete(profileID)
                .then((response) => {
                    if (response.status === 200) {
                        commit("DELETE_PROFILE", profileID);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);

                });
        });
    },
};

const mutations = {
    ADD_PROFILE: (state, profile) => state.profiles.unshift(profile),
    SET_PROFILE: (state, profiles) => (state.profiles = profiles),

    UPDATE_PROFILE: (state, profile) => {
        const index = state.profiles.findIndex(
            (m) => m.id === profile.id
        );

        if (index !== -1) {
            state.profiles.splice(index, 1, profile);
        }
    },

    DELETE_PROFILE: (state, profileID) => {
        state.profiles = state.profiles.filter(
            (profile) => profile.id !== profileID
        );
    },
};
export default { state, actions, mutations };